// extracted by mini-css-extract-plugin
export var quillEditor = "_gg-1";
export var variable = "_gg-0";